import { $set, update } from 'qim';

import { createReducer } from '@zapier/toolbox-redux-framework';

import ActionTypes from 'app/viewport/ActionTypes';

const initialState = {
  isNotificationsDropdownOpen: false,
};

const handlers = {
  [ActionTypes.OPEN_NOTIFICATIONS_DROPDOWN](state) {
    return update([['isNotificationsDropdownOpen', $set(true)]], state);
  },

  [ActionTypes.CLOSE_NOTIFICATIONS_DROPDOWN](state) {
    return update([['isNotificationsDropdownOpen', $set(false)]], state);
  },
};

export default createReducer(handlers, initialState);
